<template>

    <div class="cookie__container" v-if="showCookieBar">

        <p class="cookie__text">{{ $t('cookie_text') }}</p>

        <button class="cookie__button-accept pointer" @click="accept">{{ $t('cookie_cta') }}</button>

    </div>

</template>

<script>

import Storage from '@/helpers/storage'

import Tag from '@/modules/tag'

export default {

    name: 'cookie-law',

    watch: {
        '$route'(to) {

            if(Storage.getItem('obvCookie')) {
                return
            }
            this.showCookieBar = !(to.fullPath.indexOf('/fox') > -1)
        }
    },

    data() {
        return {
            showCookieBar: false
        }
    },

    mounted() {

        if (!Storage.getItem('obvCookie') && this.$route.fullPath.indexOf('/fox') === -1) {

            this.showCookieBar = true

        }

    },

    methods: {

        accept() {

            this.showCookieBar = false

            Storage.setItem('obvCookie', true)

            // waiting for V2, initTracking in app.js
            // Tag.initTracking(this)

        }
    }

}
</script>

<style scoped lang="scss">


    .cookie {

        &__container {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            display: flex;
            flex-direction: row;
            background-color: $white;
            min-height: 78px;
            justify-content: space-between;
            align-items: center;
            padding: 16px;
            border-top: 2px solid $aquamarine;
            z-index: 10;
            @media screen and (min-width: $above-tablet-length) {
                padding: 16px 160px;

            }
        }

        &__text {
            color: $midnight;
            font-size: 12px;
            line-height: 14px;
            display: flex;
            align-items: center;
            text-align: left;
        }

        &__button-accept {
            height: 40px;
            border-radius: 100px;
            background-color: $aquamarine;
            font-size: 17px;
            line-height: 20px;
            color: $white;
            min-width: 160px;
            margin-left: 32px;
            font-weight: bold;
        }
    }

</style>
